import urlConfig from "./urlConfig";
function getModifiedOrigin(url) {
    var _a;
    const DEFAULT_LANGUAGE = "en";
    const { origin } = window.location;
    let ULP;
    try {
        ULP = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("i18nextLng");
    }
    catch (error) {
        console.log("[ERROR] accessing localStorage for i18nextLng:");
    }
    if (!ULP) {
        console.log("[INFO] i18nextLng not found, using default language.");
        ULP = DEFAULT_LANGUAGE;
    }
    if (ULP === "fr") {
        console.log("[INFO] Origin:", origin);
        return url.replace(origin + "/", origin + "/fr-lan_");
    }
    return url;
}
function windowOpen(url, target = "_blank") {
    if (!url) {
        console.log("[ERROR] URL is undefined or empty.");
        return;
    }
    const modifiedUrl = getModifiedOrigin(url);
    console.log("[INFO] Opening URL:", modifiedUrl);
    window.open(modifiedUrl, target);
}
export const handleHelpClick = (pathname, loggedInRole) => {
    if (loggedInRole === "PMA" || loggedInRole === "PFA") {
        loggedInRole = "PA";
    }
    console.log(`[INFO] Handling help click for pathname: ${pathname} and role: ${loggedInRole}`);
    if (pathname.includes("/insights/reports")) {
        windowOpen(urlConfig.usageReports[loggedInRole], "_blank");
    }
    else if (pathname.includes("/insights/dashboard")) {
        windowOpen(urlConfig.insightsDashboard[loggedInRole], "_blank");
    }
    else if (pathname.includes("/app/home")) {
        windowOpen(urlConfig.homePage[loggedInRole], "_blank");
    }
    else if (pathname.includes("/sms/Register/sender-addresses")) {
        windowOpen(urlConfig.smsSenderAddress[loggedInRole], "_blank");
    }
    else if (pathname.includes("/sms/manage-templates")) {
        windowOpen(urlConfig.smsTemplates[loggedInRole], "_blank");
    }
    else if (pathname.includes("/sms/my-campaigns")) {
        windowOpen(urlConfig.smsCampaigns[loggedInRole], "_blank");
    }
    else if (pathname.includes("/sms/smpp-session")) {
        windowOpen(urlConfig.smppSession[loggedInRole], "_blank");
    }
    else if (pathname.includes("/voice/campaign")) {
        windowOpen(urlConfig.voiceCampaign[loggedInRole], "_blank");
    }
    else if (pathname.includes("/voice/file-manager")) {
        windowOpen(urlConfig.voiceFileManager[loggedInRole], "_blank");
    }
    else if (pathname.includes("/whatsapp/getting-started")) {
        windowOpen(urlConfig.whatsappProfile[loggedInRole], "_blank");
    }
    else if (pathname.includes("/whatsapp/templates")) {
        windowOpen(urlConfig.whatsappTemplates[loggedInRole], "_blank");
    }
    else if (pathname.includes("/whatsapp/my-campaigns")) {
        windowOpen(urlConfig.whatsAppCampaign[loggedInRole], "_blank");
    }
    else if (pathname.includes("/studio/dashboard/myFlows")) {
        windowOpen(urlConfig.studioDashboard[loggedInRole], "_blank");
    }
    else if (pathname.includes("/studio/editor")) {
        windowOpen(urlConfig.studioEditor[loggedInRole], "_blank");
    }
    else if (pathname.includes("/myplans/packages")) {
        windowOpen(urlConfig.packages[loggedInRole], "_blank");
    }
    else if (pathname.includes("/myplans/ratesheets")) {
        windowOpen(urlConfig.ratesheets[loggedInRole], "_blank");
    }
    else if (pathname.includes("/user-management/roles")) {
        windowOpen(urlConfig.roles[loggedInRole], "_blank");
    }
    else if (pathname.includes("/user-management/users")) {
        windowOpen(urlConfig.users[loggedInRole], "_blank");
    }
    else if (pathname.includes("/contacts/distribution-list")) {
        windowOpen(urlConfig.distributionList[loggedInRole], "_blank");
    }
    else if (pathname.includes("/contacts/contact-list")) {
        windowOpen(urlConfig.contactList[loggedInRole], "_blank");
    }
    else if (pathname.includes("/contacts/contact-group")) {
        windowOpen(urlConfig.contactGroup[loggedInRole], "_blank");
    }
    else if (pathname.includes("/segmentation")) {
        windowOpen(urlConfig.segmentation[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Logs/Activity")) {
        windowOpen(urlConfig.logsActivity[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Logs/Debug")) {
        windowOpen(urlConfig.logsDebug[loggedInRole], "_blank");
    }
    else if (pathname.includes("/notification_PA")) {
        windowOpen(urlConfig.notificationPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Logs/Enterprise")) {
        windowOpen(urlConfig.logsEnterprise[loggedInRole], "_blank");
    }
    else if (pathname.includes("/NumbersEA")) {
        windowOpen(urlConfig.numbersEA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/insights/usage-reports")) {
        windowOpen(urlConfig.reportsPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/sms/sender-address-specifications")) {
        windowOpen(urlConfig.smsSenderAddressPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/whatsapp/profiles-info")) {
        windowOpen(urlConfig.whatsappProfilePA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/notification")) {
        windowOpen(urlConfig.notification[loggedInRole], "_blank");
    }
    else if (pathname.includes("/NumbersPA")) {
        windowOpen(urlConfig.numbersPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/billing-pricing/rate-sheets")) {
        windowOpen(urlConfig.rateSheetPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/billing-pricing/packages")) {
        windowOpen(urlConfig.packagesPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/billing-pricing/wallets")) {
        windowOpen(urlConfig.walletsPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/billing-pricing/invoicing")) {
        windowOpen(urlConfig.invoicingPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/accounts")) {
        windowOpen(urlConfig.accountsPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Logs/Enterprise")) {
        windowOpen(urlConfig.logsEnterprise[loggedInRole], "_blank");
    }
    else if (pathname.includes("/email/my-campaigns")) {
        windowOpen(urlConfig.emailCampaigns[loggedInRole], "_blank");
    }
    else if (pathname.includes("/email/email-templates")) {
        windowOpen(urlConfig.emailTemplates[loggedInRole], "_blank");
    }
    else if (pathname.includes("/email/Register/email-addresses")) {
        windowOpen(urlConfig.emailAddressEA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Providers")) {
        windowOpen(urlConfig.providersPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/Routing")) {
        windowOpen(urlConfig.routersPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/email/email-address-specifications")) {
        windowOpen(urlConfig.emailAddressPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policy/QuietTime")) {
        windowOpen(urlConfig.quietTime[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policy/contentfilter")) {
        windowOpen(urlConfig.contentFilter[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policy/blacklist/msisdn")) {
        windowOpen(urlConfig.blacklist[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policy/dnd/msisdn")) {
        windowOpen(urlConfig.dnd[loggedInRole], "_blank");
    }
    else if (pathname.includes("/wallet/CreditLimitPA")) {
        windowOpen(urlConfig.walletsPA[loggedInRole], "_blank");
    }
    else if (pathname.includes("/change-profile")) {
        window.open(urlConfig.changeProfile[loggedInRole], "_blank");
    }
    else if (pathname.includes("/deviceList")) {
        window.open(urlConfig.npaasDeviceList[loggedInRole], "_blank");
    }
    else if (pathname.includes("/deviceListForm/_add")) {
        window.open(urlConfig.npaasDeviceListCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/deviceListForm/_edit")) {
        window.open(urlConfig.npaasDeviceListEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/bulkUploadHistory")) {
        window.open(urlConfig.npaasDeviceBulkUploadHistory[loggedInRole], "_blank");
    }
    else if (pathname.includes("/deviceType")) {
        window.open(urlConfig.npaasDeviceType[loggedInRole], "_blank");
    }
    else if (pathname.includes("/createDeviceTypeForm/_add")) {
        window.open(urlConfig.npaasDeviceTypeCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/createDeviceTypeForm/_edit")) {
        window.open(urlConfig.npaasDeviceTypeEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyList")) {
        window.open(urlConfig.npaasPolicyList[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyListForm/_add")) {
        window.open(urlConfig.npaasPolicyListCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyListForm/_edit")) {
        window.open(urlConfig.npaasPolicyListEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyRules")) {
        window.open(urlConfig.npaasPolicyRule[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyRuleForm/_add")) {
        window.open(urlConfig.npaasPolicyRuleCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/policyRuleForm/_edit")) {
        window.open(urlConfig.npaasPolicyRuleEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/ruleCriteria")) {
        window.open(urlConfig.npaasRuleCriteria[loggedInRole], "_blank");
    }
    else if (pathname.includes("/ruleCriteriaForm/_add")) {
        window.open(urlConfig.npaasRuleCriteriaCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/ruleCriteriaForm/_edit")) {
        window.open(urlConfig.npaasRuleCriteriaEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/ruleEngine")) {
        window.open(urlConfig.npaasRuleEngine[loggedInRole], "_blank");
    }
    else if (pathname.includes("/addRule/_add")) {
        window.open(urlConfig.npaasRuleEngineCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/editRule/_edit")) {
        window.open(urlConfig.npaasRuleEngineEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/cloneRule/_clone")) {
        window.open(urlConfig.npaasRuleEngineClone[loggedInRole], "_blank");
    }
    else if (pathname.includes("/applications")) {
        window.open(urlConfig.npaasApplications[loggedInRole], "_blank");
    }
    else if (pathname.includes("/applicationForm/_add")) {
        window.open(urlConfig.npaasApplicationsCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/applicationForm/_edit")) {
        window.open(urlConfig.npaasApplicationsEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/consents")) {
        window.open(urlConfig.npaasConsent[loggedInRole], "_blank");
    }
    else if (pathname.includes("/consentEditForm/_edit")) {
        window.open(urlConfig.npaasConsentEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/consentBulkUploadHistory")) {
        window.open(urlConfig.npaasConsentBulkuploadViewHistory[loggedInRole], "_blank");
    }
    else if (pathname.includes("/mnpProfileList")) {
        window.open(urlConfig.npaasMNPProfile[loggedInRole], "_blank");
    }
    else if (pathname.includes("/profileConfiguration/_add")) {
        window.open(urlConfig.npaasMNPProfileCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/profileConfiguration/_edit")) {
        window.open(urlConfig.npaasMNPProfileEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/provider_list")) {
        window.open(urlConfig.npaasProviderProfiles[loggedInRole], "_blank");
    }
    else if (pathname.includes("/provider_form/_add")) {
        window.open(urlConfig.npaasProviderProfilesCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/provider_form/_edit")) {
        window.open(urlConfig.npaasProviderProfilesEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/prefixDiscoveryList")) {
        window.open(urlConfig.npaasPrefixBasedDiscovery[loggedInRole], "_blank");
    }
    else if (pathname.includes("/discovery-form/_add")) {
        window.open(urlConfig.npaasPrefixBasedDiscoveryCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/discovery-form/_edit")) {
        window.open(urlConfig.npaasPrefixBasedDiscoveryEdit[loggedInRole], "_blank");
    }
    else if (pathname.includes("/prefixBulkUploadHistory")) {
        window.open(urlConfig.npaasPrefixBasedDiscoveryViewTheBulkUploadRecordHistory[loggedInRole], "_blank");
    }
    else if (pathname.includes("/subscriptions")) {
        window.open(urlConfig.npaasSubscriptions[loggedInRole], "_blank");
    }
    else if (pathname.includes("/eventRecords")) {
        window.open(urlConfig.npaasEventRecords[loggedInRole], "_blank");
    }
    else if (pathname.includes("/dashboard/network")) {
        window.open(urlConfig.dashBoardNetwork[loggedInRole], "_blank");
    }
    else if (pathname.includes("/apiPortfolio")) {
        window.open(urlConfig.npaasApiPortfolio[loggedInRole], "_blank");
    }
    else if (pathname.includes("/apiProducts")) {
        window.open(urlConfig.npaasApiProduct[loggedInRole], "_blank");
    }
    else if (pathname.includes("/productForm/_add")) {
        window.open(urlConfig.npaasApiProductCreate[loggedInRole], "_blank");
    }
    else if (pathname.includes("/productSubscription")) {
        window.open(urlConfig.npaasProductSubscription[loggedInRole], "_blank");
    }
    console.log("[DEBUG] No specific help URL found for this pathname.");
};
